<template>
  <v-app
    class="app"
    :class="{ 'logged-in-app': isLoggedIn, [whitelabel.brand]: true }"
  >
    <DynamicNavDrawer
      :drawerOpen="loginDrawerOpen"
      @drawerClosed="drawerClosed"
      :type="'signin'"
    >
      <template v-slot:content>
        <DrawerSignIn
          @signupClicked="signupClicked"
          :drawerOpen="loginDrawerOpen"
          @successResetPassword="successResetPassword"
        />
      </template>
    </DynamicNavDrawer>

    <DynamicNavDrawer
      :drawerOpen="signupDrawerOpen"
      @drawerClosed="signupDrawerClosed"
      :type="'signup'"
    >
      <template v-slot:content>
        <DrawerSignUp @loginClicked="loginClicked" />
      </template>
    </DynamicNavDrawer>

    <GeneralBanner
      v-if="
        website && !isLandingSimple && !alwaysStickyHeader && showGeneralBanner
      "
      :bannerText="'Need help?'"
      :bannerLinkText="'Call me back'"
      :isFunction="true"
      @generalBannerFunction="generalBannerFunction"
    />
    <CoBrandedBanner
      v-else-if="
        website &&
        !isLandingSimple &&
        !alwaysStickyHeader &&
        showCoBrandedBanner
      "
      :bannerText="'A proud partnership with'"
    />

    <FullStoryHead v-if="loadFullStory" />
    <LoggedInAsBanner v-if="isLoggedInAsSomeoneElse" />
    <NavBarAlternative
      v-if="website"
      @loginClicked="loginClicked"
      @signupClicked="signupClicked"
    />
    <NavBarLeadProvider v-else-if="isLeadProvider" />
    <NavBar v-else-if="!isAdvisorEnrolment" />

    <ReferAFriend v-if="showReferAFriend" />
    <CompetitionBanner v-if="showCompetitionBanner" />
    <v-main
      class="app-content"
      :class="{ 'logged-in-app-content': isLoggedIn }"
    >
      <router-view />
    </v-main>
    <OldMutualFooterRedesign
      v-if="whitelabel.brand == 'oldmutual' || whitelabel.brand == 'teba'"
      :home="{}"
    />
    <Footer v-else-if="whitelabel.brand == 'quickwill'" />

    <ErrorSnackbar v-model="showError" :error="errorMessage" />
    <v-snackbar bottom left :value="updateExists" :timeout="-1" color="primary">
      An update is available
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="refreshApp()"> Update </v-btn>
      </template>
    </v-snackbar>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
    <RequestACallDialog
      :showRequestACallDialog.sync="showRequestACallDialog"
      @success="showSuccessMessage"
    />
    <CallRequestConfirmationDialog
      :showConfirmationDialog.sync="showCallRequestConfirmation"
      :leadData="callRequestLeadData"
    />
  </v-app>
</template>

<script>
import NavBar from "./components/header/NavBar.vue";
import NavBarAlternative from "./components/header/NavBarAlternative.vue";
import FullStoryHead from "./components/head/FullStoryHead.vue";
import Footer from "./components/common/Footer.vue";
import ErrorSnackbar from "./components/common/ErrorSnackbar.vue";
import LoggedInAsBanner from "./components/header/LoggedInAsBanner.vue";
import ReferAFriend from "./components/referrals/ReferAFriend.vue";
import OldMutualFooter from "./components/old_mutual/OldMutualFooter.vue";
import { HOME_QUERY } from "./constants/graphql/home";
import CompetitionBanner from "./components/competition/CompetitionBanner.vue";
import EstateAdministrationCostCalculatorBanner from "./components/common/GeneralBanner.vue";
import OldMutualFooterRedesign from "./components/old_mutual/OldMutualFooterRedesign.vue";
import DynamicNavDrawer from "./components/guest/DynamicNavDrawer.vue";
import DrawerSignIn from "./components/guest/DrawerSignIn.vue";
import DrawerSignUp from "./components/guest/DrawerSignUp.vue";
import SuccessSnackbar from "./components/common/SuccessSnackbar.vue";
import GeneralBanner from "./components/common/GeneralBanner.vue";
import RequestACallDialog from "./components/guest/dialogs/RequestACallDialog.vue";
import CoBrandedBanner from "./components/common/CoBrandedBanner.vue";
import CallRequestConfirmationDialog from "./components/guest/dialogs/CallRequestConfirmationDialog.vue";
import NavBarLeadProvider from "./components/header/NavBarLeadProvider.vue";

export default {
  name: "App",
  metaInfo() {
    if (process.env.VUE_APP_RUNNING_CONFIGURATION !== "production") {
      this.metaData = this.whitelabel.developmentMeta;
    }
    return {
      meta: this.metaData,
      link: [
        { rel: "icon", href: this.whitelabel.meta.links.favicon },
        { rel: "stylesheet", href: this.whitelabel.meta.links.font },
      ],
    };
  },
  head() {
    return {
      title: {
        inner: this.whitelabel.pageTitle,
        complement: this.whitelabel.name,
      },
      style: [
        {
          type: "text/css",
          inner: `#app { font-family: ${this.whitelabel.fontFamily} } .v-application .text-subtitle-1 { font-family: ${this.whitelabel.fontFamily}!important }`,
          undo: false,
        },
      ],
    };
  },
  components: {
    NavBar,
    NavBarAlternative,
    NavBarLeadProvider,
    FullStoryHead,
    Footer,
    ErrorSnackbar,
    LoggedInAsBanner,
    ReferAFriend,
    OldMutualFooter,
    CompetitionBanner,
    EstateAdministrationCostCalculatorBanner,
    GeneralBanner,
    CoBrandedBanner,
    OldMutualFooterRedesign,
    DynamicNavDrawer,
    DrawerSignIn,
    DrawerSignUp,
    SuccessSnackbar,
    RequestACallDialog,
    CallRequestConfirmationDialog,
  },
  data() {
    return {
      loginDrawerOpen: false,
      signupDrawerOpen: false,
      errorMessage: null,
      showError: false,
      showAlert: false,
      alertMessage: null,
      home: {},
      scripts: [],
      metaData: [],
      website: false,
      websiteUrls: [
        "HomeAlternative",
        "HowItWorks",
        "OurSolutions",
        "Articles",
        "Article",
        "FAQs",
        "EstateAdministrationCostCalculator",
        "UserLinkLandingPageRedesign",
        "TermsAndConditions",
        "LandingSimple",
        "PageNotFound",
        "Register",
        "Login",
        "AdviserEnrolment",
        "Calculators",
        "CGT Calculator",
        "Estate Cost Calculator",
        "Home1",
        "Home2",
        "Home3",
      ],
      showRequestACallDialog: false,
      showCallRequestConfirmation: false,
      callRequestLeadData: null,
    };
  },
  created() {
    this.updateRoutes();
    this.checkUrlParameters();
  },
  computed: {
    loadFullStory() {
      return this.isLoggedIn && process.env.VUE_APP_LOAD_FULL_STORY == "true";
    },
    updateExists() {
      return this.$store.getters.newVersionAvailable;
    },
    showReferAFriend() {
      return (
        this.isLoggedIn &&
        this.$store.getters.isTestator &&
        this.testator?.company?.referAFriend
      );
    },
    hasCompetition() {
      return this.home?.competition?.competitionActive;
    },
    showCompetitionBanner() {
      return this.hasCompetition;
    },
    showEstateAdministrationCostBanner() {
      return this.$route.path === "/" || this.$route.path === "/login";
    },
    isMobile() {
      return this.$isMobileDevice();
    },
    isLandingSimple() {
      return this.$route.name === "LandingSimple";
    },
    showGeneralBanner() {
      return (
        this.whitelabel.landingPageBanner === "general" &&
        !this.isAdvisorEnrolment
      );
    },
    showCoBrandedBanner() {
      return this.whitelabel.landingPageBanner === "co-branded";
    },
    isPageNotFound() {
      return this.$route.name === "PageNotFound";
    },
    isLoginSignup() {
      return this.$route.name === "Login" || this.$route.name === "Register";
    },
    alwaysStickyHeader() {
      return this.isPageNotFound || this.isLoginSignup;
    },
    isAdvisorEnrolment() {
      return this.$route.name === "AdviserEnrolment";
    },
    isLeadProvider() {
      return this.$store.getters.isLeadProvider;
    },
  },
  mounted() {
    this.reloadErrorMessage();
  },
  methods: {
    successResetPassword() {
      this.loginDrawerOpen = false;
      this.alertMessage =
        this.whitelabel.authentication.resetPassword.successMessage;
      this.showAlert = true;
    },
    loginClicked() {
      this.signupDrawerOpen = false;
      this.loginDrawerOpen = true;
    },
    signupClicked() {
      this.loginDrawerOpen = false;
      this.signupDrawerOpen = true;
    },
    drawerClosed() {
      this.loginDrawerOpen = false;
    },
    signupDrawerClosed() {
      this.signupDrawerOpen = false;
    },
    reloadErrorMessage() {
      // show error message if page was reload due to error and version mismatch
      if (/[?&]reload=/.test(window.location.search)) {
        this.errorMessage = "Sorry, something went wrong. Please try again.";
        this.showError = true;
      }
    },
    refreshApp() {
      window.location.reload();
    },
    updateRoutes() {
      this.website =
        this.whitelabel.brand !== "quickwill" &&
        this.websiteUrls.includes(this.$route.name);
    },
    generalBannerFunction() {
      dataLayer.push({
        event: "callbackpopup",
        omuserid: this.$store.getters?.userId,
      });

      this.showRequestACallDialog = true;
    },
    showSuccessMessage(success) {
      if (success) {
        this.successMessage = "Thank you. An advisor will contact you.";
        this.showSuccess = true;
      } else {
        this.showError = true;
      }
    },
    checkUrlParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("cmb") === "true") {
        const leadData = {
          firstName: urlParams.get("contact_name")?.split(" ")[0] || "",
          surname:
            urlParams.get("contact_name")?.split(" ").slice(1).join(" ") || "",
          email: urlParams.get("email_from") || "",
          contactNumber:
            urlParams.get("phone") || urlParams.get("mobile") || "",
          userAgent: navigator.userAgent,
          referrer: document.referrer,
        };

        this.callRequestLeadData = leadData;
        this.showCallRequestConfirmation = true;
      }

      if (urlParams.get("cmbform") === "true") {
        this.generalBannerFunction();
      }
    },
  },
  watch: {
    $route() {
      this.updateRoutes();
    },
  },
  apollo: {
    home: {
      query: HOME_QUERY,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>

<style lang="scss">
@import "./constants/styles/global.scss";
@import "./constants/styles/lists.scss";
@import "./constants/styles/modal.scss";
@import "./constants/styles/peach-payment.scss";
@import "./constants/styles/whitelabel-imports.scss";
@import "./constants/styles/tooltip.scss";
</style>
